import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = ({ theme }) => ({
  padding: `0 ${theme.margin.large}`,
  minWidth: '6em',
  width: 'max-content',
  maxWidth: '30vw',
  maxHeight: '180px',
  overflowY: 'scroll',
  position: 'relative',

  '::-webkit-scrollbar': {
    display: 'none',
  },
  '-ms-overflow-style': 'none',
  scrollbarWidth: 'none',

  direction: theme.origDirection,
  verticalAlign: 'top',
  ':first-child': {
    marginLeft: '0',
  },
  extend: [
    {
      condition: theme.origDirection === 'ltr',
      style: {
        marginLeft: theme.margin.small,
      },
    },
    {
      condition: theme.origDirection === 'rtl',
      style: {
        marginRight: theme.margin.small,
      },
    },
  ],
});

const Menu = React.forwardRef(({ children }, ref) => {
  const { css } = useFela();

  return (
    <div ref={ref} className={css(rules)}>
      {children}
    </div>
  );
});

Menu.propTypes = {
  children: PropTypes.node,
};

export default React.memo(Menu);
